import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, AlertTriangle, Clock, SearchCheck, ArrowRight, Plug } from "lucide-react";
import { api } from "../../services/api";

function Metric({ icon: Icon, label, value, tone, sub }) {
  return (
    <div className="metric" style={tone ? { borderTopColor: tone } : {}}>
      <div className="metric-icon" style={tone ? { background: `${tone}14`, color: tone } : {}}><Icon size={18} /></div>
      <div className="metric-value">{value}</div>
      <div className="metric-label">{label}</div>
      {sub && <div className="metric-sub">{sub}</div>}
    </div>
  );
}

export default function RVCommandCenter() {
  const [data, setData] = useState(null);
  const nav = useNavigate();

  useEffect(() => { api.rvSummary().then(setData); }, []);
  if (!data) return <div className="loading-page">Pre-computing vehicle compliance intelligence…</div>;

  const k = data.kpis;
  return (
    <div className="dash" data-testid="rv-command-center">
      <div className="vans-eyebrow" style={{ color: "#b91c1c" }}>IGL · Refuel Validation · Vehicle Compliance Intelligence Today · {data.today}</div>
      <h1 className="vans-title" style={{ margin: "4px 0 4px" }}>IGL Safety Command Center</h1>
      <p className="vans-sub" style={{ maxWidth: 780, marginBottom: 18 }}>
        DotIQ pre-computes a compliance state for every CNG vehicle <b>before it reaches the pump</b> — correlating VAHAN identity,
        PESO hydro-test certificates, cylinder serials and the station's observed configuration into an explainable flag.
      </p>

      <div className="metrics-row">
        <Metric icon={ShieldCheck} label="Vehicles pre-validated" value={k.pre_validated.toLocaleString("en-IN")} tone="#059669" sub="no pre-identified exception" />
        <Metric icon={SearchCheck} label="Require verification" value={k.verification_required} tone="#ea580c" />
        <Metric icon={AlertTriangle} label="Critical compliance flags" value={k.critical_flags} tone="#dc2626" />
        <Metric icon={Clock} label="Hydro-tests expiring ≤30d" value={k.expiring_30d} tone="#ca8a04" />
        <Metric icon={Plug} label="Systems connected" value={data.systems_connected} tone="#0f172a" />
      </div>

      <section className="panel" style={{ marginTop: 8 }}>
        <div className="panel-h"><span>Vehicles requiring action</span></div>
        <div className="rv-table">
          <div className="rv-thead">
            <span>Plate</span><span>Risk</span><span>Reason</span><span>Station / Area</span><span></span>
          </div>
          {data.queue.map((v) => (
            <button key={v.plate} className="rv-row" onClick={() => nav(`/iglrv/vehicles/${v.plate}`)} data-testid={`rv-queue-${v.plate}`}>
              <span className="rv-plate">{v.plate}</span>
              <span><i className={`rv-dot ${v.state_meta.dot}`} /> {v.state_meta.chip}</span>
              <span className="rv-reason">{v.reason}</span>
              <span className="rv-area">{v.region}</span>
              <span className="rv-why">View why <ArrowRight size={13} /></span>
            </button>
          ))}
        </div>
      </section>
    </div>
  );
}
